
module.exports = {

    buttons: {

        prevGame: {
            frames:{
                normal:'side_arrow_left_on.png',
                pressed:'side_arrow_left_on.png',
                disabled:'side_arrow_left_off.png',
                hover: 'side_arrow_left_on.png'
            },
            position:{x:9, y:466},
            scene: 'lobby'
        },

        nextGame: {
            frames:{
                normal:'side_arrow_right_on.png',
                pressed:'side_arrow_right_on.png',
                disabled:'side_arrow_right_off.png',
                hover: 'side_arrow_right_on.png'
            },
            position:{x:1837, y:466},
            scene: 'lobby'
        },

        lobbyStopPari: {
            frames:{
                normal:'button_lobby_stop_pari_on.png',
                pressed:'button_lobby_stop_pari_on.png',
                disabled:'button_lobby_stop_pari_off.png',
                hover: 'button_lobby_stop_pari_on.png'
            },
            position:{x:23, y:4},
            scene: 'lobby'
        },

        lobbySound: {
            frames:{
                normal:'button_lobby_sound_on.png',
                pressed:'button_lobby_sound_on.png',
                disabled:'button_lobby_sound_off.png',
                hover: 'button_lobby_sound_on.png'
            },
            position:{x:1612, y:4},
            scene: 'lobby'
        },

        lobbyBell: {
            frames:{
                normal:'button_lobby_bell_on.png',
                pressed:'button_lobby_bell_on.png',
                disabled:'button_lobby_bell_off.png',
                hover: 'button_lobby_bell_on.png'
            },
            position:{x:1683, y:4},
            scene: 'lobby'
        },

        lobbyInfo: {
            frames:{
                normal:'button_lobby_info_on.png',
                pressed:'button_lobby_info_on.png',
                disabled:'button_lobby_info_on.png',
                hover: 'button_lobby_info_on.png'
            },
            position:{x:1760, y:4},
            scene: 'lobby'
        },

        changeGame: {
            frames:{
                normal:'button_lobby_change_game_on.png',
                pressed:'button_lobby_change_game_on.png',
                disabled:'button_lobby_change_game_off.png',
                hover: 'button_lobby_change_game_on.png'
            },
            position:{x:1359, y:994},
            scene: 'lobby'
        },

        changeStatus: {
            frames:{
                normal:'button_lobby_change_status_on.png',
                pressed:'button_lobby_change_status_on.png',
                disabled:'button_lobby_change_status_off.png',
                hover: 'button_lobby_change_status_on.png'
            },
            position:{x:1514, y:994},
            scene: 'lobby'
        },

        choiceGame: {
            frames:{
                normal:'button_lobby_chose_game_on.png',
                pressed:'button_lobby_chose_game_on.png',
                disabled:'button_lobby_chose_game_off.png',
                hover: 'button_lobby_chose_game_on.png'
            },
            position:{x:1763, y:994},
            scene: 'lobby'
        },

        infoExit: {
            frames:{
                normal:'button_info_back_on.png',
                pressed:'button_info_back_on.png',
                disabled:'button_info_back_off.png',
                hover: 'button_info_back_on.png'
            },
            position:{x:32, y:995},
            scene: 'info'
        },

        infoBack: {
            frames:{
                normal:'button_info_arrow_back_on.png',
                pressed:'button_info_arrow_back_on.png',
                disabled:'button_info_arrow_back_off.png',
                hover: 'button_info_arrow_back_on.png'
            },
            position:{x:809, y:995},
            scene: 'info'
        },

        infoForward: {
            frames:{
                normal:'button_info_arrow_fwd_on.png',
                pressed:'button_info_arrow_fwd_on.png',
                disabled:'button_info_arrow_fwd_off.png',
                hover: 'button_info_arrow_fwd_on.png'
            },
            position:{x:968, y:995},
            scene: 'info'
        },

        infoBell: {
            frames:{
                normal:'button_info_bell_on.png',
                pressed:'button_info_bell_on.png',
                disabled:'button_info_bell_off.png',
                hover: 'button_info_bell_on.png'
            },
            position:{x:1746, y:995},
            scene: 'info'
        },

        termsAgree: {
            frames:{
                normal:'terms_agree_on.png',
                pressed:'terms_agree_on.png',
                disabled:'terms_agree_off.png',
                hover: 'terms_agree_on.png'
            },
            position:{x:33, y:998},
            scene: 'term'
        },

        prevTermPage: {
            frames:{
                normal:'terms_prev_button_on.png',
                pressed:'terms_prev_button_on.png',
                disabled:'terms_prev_button_off.png',
                hover: 'terms_prev_button_on.png'
            },
            position:{x:811, y:998},
            scene: 'term'
        },

        nextTermPage: {
            frames:{
                normal:'terms_next_button_on.png',
                pressed:'terms_next_button_on.png',
                disabled:'terms_next_button_off.png',
                hover: 'terms_next_button_on.png'
            },
            position:{x:970, y:998},
            scene: 'term'
        },

        termBell: {
            frames:{
                normal:'button_events_bell_on.png',
                pressed:'button_events_bell_on.png',
                disabled:'button_events_bell_off.png',
                hover: 'button_events_bell_on.png'
            },
            position:{x:1745, y:998},
            scene: 'term'
        },

        eventInfo: {
            frames:{
                normal:'button_events_info_on.png',
                pressed:'button_events_info_on.png',
                disabled:'button_events_info_off.png',
                hover: 'button_events_info_on.png'
            },
            position:{x:1574, y:998},
            scene: 'event'
        },

        eventStopPari: {
            frames:{
                normal:'button_events_stop_pari_on.png',
                pressed:'button_events_stop_pari_on.png',
                disabled:'button_events_stop_pari_off.png',
                hover: 'button_events_stop_pari_on.png'
            },
            position:{x:33, y:998},
            scene: 'event'
        },

        eventBell: {
            frames:{
                normal:'button_events_bell_on.png',
                pressed:'button_events_bell_on.png',
                disabled:'button_events_bell_off.png',
                hover: 'button_events_bell_on.png'
            },
            position:{x:1745, y:998},
            scene: 'event'
        },
    },

    frames: {

    }
};



//////////////////
// WEBPACK FOOTER
// ./cfg/userinterface-config.js
// module id = 41
// module chunks = 0